import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React, { useState } from 'react';

/* ------- Layouts ------- */
import MainLayout from './composant/MainLayout';
import DashboardLayout from './dashboard/DashboardLayout';

/* ------- Pages du site principal ------- */
import Accueil from './composant/container/Accueil/Accueil';
import CardClub from './composant/container/Clubs/cardClub';
import ClubDetails from './composant/container/Clubs/Clubinfo';
import GestionProjetsEvenements from './composant/container/Clubs/GestionProjetEvenements';
import GestionClub from './composant/container/Clubs/GestionClub';
import Connexion from './composant/container/Connexion/Connexion';
import FormulaireInscription from './composant/container/Inscriptions/FormulaireInscription';
import ProjetDetail from './composant/container/Clubs/Projet';
import ListeProjets from './composant/container/Clubs/ListeProjets';
import CalendrierProjets from './composant/container/Actu/Calendrier';
import Blog from './composant/container/Actu/blog';
import BlogPost from './composant/container/Actu/BlogPost';
import FAQ from './composant/container/Ressources/FAQ';
import RessourcesGuides from './composant/container/Ressources/Ressources';
import ReglementsClubs from './composant/container/Ressources/ReglementsClubs';
import ProtocolesInternes from './composant/container/Ressources/ProtocolesInternes';
import FicheProjet from './composant/container/Ressources/FicheProjet';
import Journal from './composant/container/Journal/Journal';
import WebRadio from './composant/container/Webradio/Webradio';
import Arts from './composant/container/Arts/Arts';
import EnConstruction from './composant/container/EnConstruction';
import LaTribune from './composant/container/LaTribune/LaTribune';

import CreateProject from './composant/container/Ressources/Guide/CreateProject';


import NewsPage from './composant/container/News/NewsPage';
import QuizLFIT from './composant/container/QuizLFIT/QuizLFIT';

/* ------- Dashboard ------- */
import Dashboard from './dashboard2/dashboard';
import PrivateRoute from './composant/PrivateRoute';

/* ------- Styles Globaux ------- */
import './composant/css/all.min.css';
import './composant/css/owl.carousel.min.css';
import './composant/css/owl.theme.default.min.css';
import './composant/css/venobox.css';
import './composant/css/custom.css';
import './composant/css/responsive.css';
import './composant/css/helper.css';
import './composant/js/bootstrap.bundle.min.js';
import './composant/Page-i18n.js'; // Importer la configuration i18n

// Importer Google Analytics manuellement
function trackPageView() {
  if (window.gtag) {
    window.gtag('config', 'G-Y1YV1YT4Y8', {
      page_path: window.location.pathname,
    });
  }
}

function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><Accueil /></MainLayout>} />
        <Route path="/Clubs" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><CardClub /></MainLayout>} />
        <Route path="/ListeProjets" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><ListeProjets /></MainLayout>} />
        <Route path="/clubs/:id" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><ClubDetails /></MainLayout>} />
        <Route path="/Projet/:id" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><ProjetDetail /></MainLayout>} />
        <Route path="/Calendrier" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><CalendrierProjets /></MainLayout>} />
        <Route path="/Blog" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><Blog /></MainLayout>} />
        <Route path="/Blog/:id" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><BlogPost /></MainLayout>} />
        <Route path="/Ressources" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><RessourcesGuides /></MainLayout>} />
        <Route path="/FAQ" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><FAQ /></MainLayout>} />
        <Route path="/Reglement" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><ReglementsClubs /></MainLayout>} />
        <Route path="/protocoles" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><ProtocolesInternes /></MainLayout>} />
        <Route path="/FicheProjet" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><FicheProjet /></MainLayout>} />
        <Route path="/Connexion" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><Connexion /></MainLayout>} />
        <Route path="/Formulaire" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><FormulaireInscription /></MainLayout>} />
        <Route path="/GestionProjets" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><GestionProjetsEvenements /></MainLayout>} />
        <Route path="/GestionClub" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><GestionClub /></MainLayout>} />
        <Route path="/EnConstruction" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><EnConstruction /></MainLayout>} />
        <Route path="/journal" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><Journal /></MainLayout>} />
        <Route path="/webradio" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><WebRadio /></MainLayout>} />
        <Route path="/arts" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><Arts /></MainLayout>} />
        <Route path="/tribune" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><LaTribune /></MainLayout>} />
        <Route path="/quizLFIT" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><QuizLFIT /></MainLayout>} />
        <Route path="/news" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><NewsPage /></MainLayout>} />
        <Route path="/Projets" element={<MainLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode}><CreateProject /></MainLayout>} />

        <Route path="/dashboard" element={<Dashboard />} />
      </Routes>
    </Router>
  );
}

export default App;
